import React, { useEffect, useMemo, useState } from 'react';
import { Dimensions, Platform, ScrollView, StyleSheet, TouchableOpacity, View } from 'react-native';
import { ModalAlignmentEnum } from '@voltmoney/types';
import { isMobile } from '../../stack/utils';
import { getScreenType } from '../bankSelectPage/BankSelect';
import { Header } from "../../header/Header";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StepperTypeTokens, TextAlignTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import { Typography } from '../../typography/Typography';
import { Divider } from '../../divider/Divider';
import { ListItem } from '../../listItem/ListItem';
import { Space } from '../../space/Space';
import { Radio } from '../../radio/Radio';
import { LENDER_ID } from '../constants';
import { Icon } from '../../icon/Icon';
import { Button } from '../../button/Button';
import LottieView from 'lottie-react-native';
import BottomSheet from '../BottomSheet';
import NeedHelpDC from '../NeedHelpDC';
const KycSummary = ({ stepperData, height, lenderId, showSecondTC, fullName, dob, address, triggerAction, radioButtonCheck1, radioButtonCheck2, disableCTA, continueToNextStep, radioButton1Check, radioButton2Check, navigateToNextStep, showSuccess, loading, goBackAction, updateKycAction, showKYCEdit, needHelpAction, isFromJupiter, contactUsDetails }) => {
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const [successLottie, setSuccessLottie] = useState("");
    const successJsonLottie = "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json";
    const [iLottieFetched, setLottieFetched] = useState(false);
    const [showKycUpdate, setShowKycUpdate] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch("https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json", {
                    method: "GET",
                });
                const responseData = await response.json();
                setSuccessLottie(responseData);
                setLottieFetched(true);
            }
            catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);
    const stepperProps = {
        data: stepperData,
        type: StepperTypeTokens.HORIZONTAL,
        onPress: null
    };
    const _headerChild = useMemo(() => {
        return (React.createElement(Header, { id: "bt_autoPay_goBack", type: HeaderTypeTokens.verification, needHelpIcon: true, needHelpAction: () => setShowNeedHelp(true), stepperProps: stepperProps, isBackButton: true, isFromJupiter: isFromJupiter, title: "KYC verification", onPress: () => {
                triggerAction({
                    ...goBackAction
                });
            } }));
    }, []);
    const renderVerification = () => {
        return (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: 260, width: '100%', closeFunction: () => {
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: false, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Platform.OS !== 'ios'
                        ? Dimensions.get('window').height + 10
                        : Dimensions.get('window').height
                    : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Dimensions.get('window').width
                    : 508, routeId: 'routeId', handleKeyboard: true }, renderVerificationSuccess())));
    };
    const renderUpdateModal = () => {
        return (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: 320, width: '100%', closeFunction: () => {
                    setShowKycUpdate(false);
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Platform.OS !== 'ios'
                        ? Dimensions.get('window').height + 10
                        : Dimensions.get('window').height
                    : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Dimensions.get('window').width
                    : 508, routeId: 'routeId', handleKeyboard: true }, renderKycUpdate())));
    };
    const renderVerificationSuccess = () => {
        return (React.createElement(View, { style: styles.successCard },
            Platform.OS === 'ios'
                && React.createElement(LottieView, { source: { uri: "https://lottie.host/34e6bfb8-a91f-4e4f-8856-7571d41cee8e/6sPdPdx4Yf.json" }, style: { width: 70, height: 70 }, autoPlay: true, loop: true }),
            Platform.OS !== "ios" &&
                React.createElement(LottieView, { source: successLottie, style: styles.successLottie, autoPlay: true, loop: true }),
            React.createElement(View, { style: styles.halfCardTitle },
                React.createElement(Typography, { label: 'KYC done successfully!', fontSize: FontSizeTokens.MD, fontWeight: '600', fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, lineHeight: 24 })),
            React.createElement(View, { style: styles.halfCardDescription },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: 'You will be redirected to next step in few seconds', fontSize: FontSizeTokens.SM, lineHeight: 20, fontWeight: '400', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Charcoal, paddingTop: 4 })),
            React.createElement(View, { style: styles.successCTA },
                React.createElement(Button, { id: 'btn_KYCSummary_originalDetailsAccept', type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: 'Continue', width: ButtonWidthTypeToken.FULL, onPress: () => {
                        triggerAction({
                            ...navigateToNextStep,
                        });
                    } }))));
    };
    const radioButton1Checked = () => {
        return triggerAction({
            ...radioButtonCheck1,
            payload: {
                ...radioButtonCheck1.payload,
                widgetId: 'radio1',
            },
        });
    };
    const radioButton2Checked = () => {
        return triggerAction({
            ...radioButtonCheck2,
            payload: {
                ...radioButtonCheck2.payload,
                widgetId: 'radio2',
            },
        });
    };
    const renderNormalBottomBar = () => {
        return (React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                justifyContent: 'center',
                width: '100%',
                paddingBottom: 16,
                backgroundColor: 'white',
            } },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    justifyContent: 'center',
                    marginBottom: 8,
                } },
                React.createElement(Typography, { label: 'Your data is secure with us', fontSize: FontSizeTokens.XXS, fontWeight: '500', lineHeight: 16, color: ColorTokens.Secondary_100, fontFamily: FontFamilyTokens.Inter })),
            React.createElement(View, { style: {
                    alignItems: 'center',
                    alignContent: 'center',
                    paddingHorizontal: 16,
                    alignSelf: 'center',
                    width: '100%',
                } },
                React.createElement(Button, { type: disableCTA
                        ? ButtonTypeTokens.LargeOutline
                        : ButtonTypeTokens.LargeFilled, label: 'Confirm', id: 'bt_kycConfirmation_confirm', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.MD, width: ButtonWidthTypeToken.FULL, loading: loading, onPress: async () => {
                        if (!loading) {
                            await triggerAction({
                                ...continueToNextStep,
                            });
                        }
                    } }))));
    };
    const renderEnhanceLimitBar = () => {
        return (React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                width: '100%',
                justifyContent: 'center',
                borderColor: '#F2F4F7',
                borderTopWidth: 1,
                paddingHorizontal: -16,
                paddingVertical: 8,
                backgroundColor: 'white',
            } },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    justifyContent: 'center',
                    marginBottom: 8,
                    marginTop: 8,
                } },
                React.createElement(Typography, { label: 'Are the above KYC details correct?', typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal })),
            React.createElement(View, { style: {
                    alignItems: 'center',
                    alignContent: 'center',
                    paddingHorizontal: 16,
                    alignSelf: 'center',
                    width: '100%',
                } },
                React.createElement(Button, { type: disableCTA
                        ? ButtonTypeTokens.LargeOutline
                        : ButtonTypeTokens.LargeFilled, label: "Yes, it's correct", id: 'bt_kycConfirmation_confirm', fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.MD, width: ButtonWidthTypeToken.FULL, loading: loading, onPress: () => {
                        triggerAction({
                            ...continueToNextStep,
                        });
                    } }),
                React.createElement(TouchableOpacity, { onPress: () => setShowKycUpdate(true), style: { marginTop: 16, marginBottom: 8 } },
                    React.createElement(Typography, { label: 'I need to update my KYC details here', typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Primary_100 })))));
    };
    const renderKycUpdate = () => {
        return (React.createElement(View, { style: {
                paddingTop: 24,
                paddingBottom: 16,
                paddingHorizontal: 16,
                alignItems: 'center',
                flex: 1,
            } },
            React.createElement(Icon, { name: IconTokens.SystemWarning, size: IconSizeTokens.XXXXXXL }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, textAlign: TextAlignTokens.center, label: 'Are you sure you want to update\nyour KYC details?' })),
            React.createElement(View, { style: { marginTop: 8, marginBottom: 24, width: '100%' } },
                React.createElement(Typography, { textAlign: TextAlignTokens.center, label: 'You will need to fetch your latest documents\nfrom DigiLocker.', typeDLS: TypographyTypeDLS.B1R })),
            React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    paddingHorizontal: 16,
                } },
                React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: 'Yes, Proceed with DigiLocker', width: ButtonWidthTypeToken.FULL, onPress: () => {
                        if (updateKycAction) {
                            triggerAction(updateKycAction);
                        }
                    } }),
                React.createElement(View, { style: { height: 12 } }),
                React.createElement(View, { style: { marginBottom: 12 } },
                    React.createElement(Button, { type: ButtonTypeTokens.LargeSoftFilled, fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, label: 'Go back', width: ButtonWidthTypeToken.FULL, onPress: () => {
                            setShowKycUpdate(false);
                        } })))));
    };
    // @ts-ignore
    return (React.createElement(View, { style: [
            styles.container,
            { height: Platform.OS === "ios" ? height - 30 : height - 16 },
        ] },
        React.createElement(View, { style: styles.headerStyle }, _headerChild),
        React.createElement(ScrollView, { style: [
                styles.contentContainer,
                { height: height - 102 },
            ] },
            React.createElement(View, { style: { marginTop: 16, marginBottom: 8 } },
                React.createElement(Typography, { label: 'Verify your KYC details', fontWeight: '600', fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Poppins })),
            React.createElement(ListItem, { title: 'Full name', subTitle: fullName, onPress: () => {
                }, leadIconName: IconTokens.Person }),
            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }),
            React.createElement(ListItem, { title: 'Date of birth', subTitle: dob, onPress: () => {
                }, leadIconName: IconTokens.Calendar }),
            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }),
            React.createElement(ListItem, { title: 'Address', subTitle: address, onPress: () => {
                }, leadIconName: IconTokens.Location, subTitleLineHeight: 24 }),
            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }),
            lenderId.toLowerCase() === LENDER_ID.DSP.toLowerCase() && React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(TouchableOpacity, { style: { flexDirection: 'row' }, onPress: () => {
                    triggerAction({
                        ...radioButtonCheck1,
                        payload: {
                            ...radioButtonCheck1.payload,
                            widgetId: 'radio1',
                        },
                    });
                } }, showSecondTC && lenderId.toLowerCase() === LENDER_ID.DSP.toLowerCase() && (React.createElement(React.Fragment, null,
                React.createElement(TouchableOpacity, { style: { flexDirection: 'row' }, onPress: () => {
                        triggerAction({
                            ...radioButtonCheck1,
                            payload: {
                                ...radioButtonCheck1.payload,
                                widgetId: 'radio1',
                            },
                        });
                    } },
                    React.createElement(View, { style: { marginRight: 8 } },
                        React.createElement(Radio, { id: 'rb_kycConfirmation_check', color: ColorTokens.Primary_100, isChecked: radioButton1Check, size: IconSizeTokens.MD, onPressUnChecked: radioButton1Checked, onPressChecked: radioButton1Checked })),
                    React.createElement(Typography, { label: 'I confirm that I am a resident Indian individual.', color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.XS, lineHeight: 16 })),
                React.createElement(Space, { size: SizeTypeTokens.LG })))),
            React.createElement(Space, { size: SizeTypeTokens.LG }),
            showSecondTC && lenderId.toLowerCase() === LENDER_ID.DSP.toLowerCase() && (React.createElement(TouchableOpacity, { style: { flexDirection: 'row' }, onPress: () => {
                    triggerAction({
                        ...radioButtonCheck2,
                        payload: {
                            ...radioButtonCheck2.payload,
                            widgetId: 'radio2',
                        },
                    });
                } },
                React.createElement(View, { style: { marginRight: 8 } },
                    React.createElement(Radio, { id: 'rb_kycConfirmation_check', color: ColorTokens.Primary_100, isChecked: radioButton2Check, size: IconSizeTokens.MD, onPressChecked: radioButton2Checked, onPressUnChecked: radioButton2Checked })),
                React.createElement(Typography, { label: Platform.OS === 'web'
                        ? 'I confirm that my current address is same as permanent address as shown above.'
                        : 'I confirm that my current address is same as permanent\naddress as shown above.', color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.XS, lineHeight: 16 }))),
            lenderId.toLowerCase() !== LENDER_ID.DSP.toLowerCase() && (React.createElement(React.Fragment, null,
                React.createElement(TouchableOpacity, { style: { flexDirection: 'row' }, onPress: () => {
                        triggerAction({
                            ...radioButtonCheck1,
                            payload: {
                                ...radioButtonCheck1.payload,
                                widgetId: 'radio1',
                            },
                        });
                    } },
                    React.createElement(View, { style: { marginRight: 8 } },
                        React.createElement(Radio, { id: 'rb_kycConfirmation_check', color: ColorTokens.Primary_100, isChecked: radioButton1Check, size: IconSizeTokens.MD, onPressChecked: radioButton1Checked, onPressUnChecked: radioButton1Checked })),
                    React.createElement(Typography, { label: Platform.OS === 'web'
                            ? 'I confirm that my current address is same as permanent address as shown above.'
                            : 'I confirm that my current address is same as permanent\naddress as shown above.', color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.XS, lineHeight: 16 })))),
            showSecondTC && lenderId.toLowerCase() !== LENDER_ID.DSP.toLowerCase() && (React.createElement(TouchableOpacity, { style: { flexDirection: 'row' }, onPress: () => {
                    triggerAction({
                        ...radioButtonCheck2,
                        payload: {
                            ...radioButtonCheck2.payload,
                            widgetId: 'radio2',
                        },
                    });
                } },
                React.createElement(View, { style: { marginRight: 8 } },
                    React.createElement(Radio, { id: 'rb_kycConfirmation_check', color: ColorTokens.Primary_100, isChecked: radioButton2Check, size: IconSizeTokens.MD, onPressUnChecked: radioButton2Checked, onPressChecked: radioButton2Checked })),
                React.createElement(Typography, { label: lenderId.toLowerCase() === LENDER_ID.TATA.toLowerCase()
                        ? 'I confirm that I am a resident Indian individual.'
                        : 'I confirm that I am a resident Indian individual and not politically exposed.', color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.XS, lineHeight: 16 })))),
        showKYCEdit
            ? renderEnhanceLimitBar()
            : renderNormalBottomBar(),
        showKycUpdate && renderUpdateModal(),
        showSuccess && renderVerification(),
        showNeedHelp && React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails, isFromJupiter: isFromJupiter })));
};
const styles = StyleSheet.create({
    container: {
        marginHorizontal: -16,
    },
    headerStyle: {
        ...(Platform.OS === 'ios' && {
            marginTop: 24,
        }),
    },
    contentContainer: {
        flex: 1,
        paddingHorizontal: 16,
        paddingBottom: 180,
    },
    successCard: {
        alignItems: 'center',
        flex: 1,
        height: 260,
        padding: 16,
    },
    successLottie: { width: 70, height: 70 },
    halfCardTitle: { marginTop: 16 },
    halfCardDescription: { marginTop: 4 },
    successCTA: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        paddingHorizontal: 16,
        marginBottom: 16,
        marginTop: 24,
    },
});
export default KycSummary;
